export default __webpack_public_path__ + "3c1e0298000077888c384ee3c473f563.png";